import React from 'react'

const SurveyRequired = () => {
    return (
        <span>*</span>
    )
}

export default SurveyRequired;